import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';
import ProfileStatusType from './ProfileStatusType';

export default class ProfileTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.magic = null;
		/** @type {string} */
		this.status = null;
		/** @type {NamedDto} */
		this.visualCaptchaType = null;
		/** @type {NamedDto} */
		this.audioCaptchaType = null;
	}

	/**
	 * @typedef {Object} _ProfileTableDtoProps
	 * @property {string} magic
	 * @property {string} status
	 * @property {NamedDto} visualCaptchaType
	 * @property {NamedDto} audioCaptchaType
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _ProfileTableDtoProps} ProfileTableDtoProps
	 */
	/**
	 *
	 * @param {ProfileTableDtoProps} props
	 * @returns {ProfileTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.magic = props.magic;
		this.status = props.status;
		this.visualCaptchaType = props.visualCaptchaType !== null ? new NamedDto().setup(props.visualCaptchaType) : null;
		this.audioCaptchaType = props.audioCaptchaType !== null ? new NamedDto().setup(props.audioCaptchaType) : null;
		return this;
	}

	getAsString(key) {
		if (key === 'status') {
			return this.status != null ? ProfileStatusType[this.status] : '';
		}
		return super.getAsString(key);
	}
}
